import React from 'react'
import {BsLinkedin} from 'react-icons/bs';
import {BsGithub} from 'react-icons/bs';
import { SiCodechef } from "react-icons/si";

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/harsh-sojitra-a47809204/" rel='noreferrer' id='social__icon' target="_blank">
            <BsLinkedin />
        </a>
        <a href="https://github.com/harshsojitra007" rel='noreferrer' id='social__icon' target="_blank">
            <BsGithub />
        </a>
        <a href="https://www.codechef.com/users/harsh_sojitra1" rel='noreferrer' id='social__icon' target="_blank">
            <SiCodechef style={{transform: 'scale(1.5)'}} />
        </a>
    </div>
  )
}

export default HeaderSocials